module.exports = __webpack_public_path__ + "media/voiceOver_01.9d00d78f.mp3";